<template>
    <div class="container">
        <div v-if="user.is_admin===0">
            <img src="./审核中.png" width="128"/>
            <p style="font-size:16px;margin:30px auto;">您的注册信息正在审核中，请审核通过后再重新登录</p>
            <el-button type="primary" @click="logout" round>重新登录</el-button>
        </div>
        <div v-else-if="user.is_admin===-1">
            <img src="./未通过.png" width="128"/>
            <i class="text-danger iconfont icon-beijujue"></i>
            <p style="font-size:16px;margin-top:30px">您的审核未通过，若有疑问请联系管理人员</p>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {

        };
    },
    computed: {
        user: function() {
            return this.$ox.session.get('user') || {};
        }
    },
    methods:{
        logout(){
            this.$ox.session.clear();
            this.$router.replace("/login");
        }
    }
};
</script>

<style scoped>
.container {
    text-align:center;
    width: 100%;
    height: 100vh;
    font-size: 24px;
    background: #f0f2f5 url(../../assets/background.png) no-repeat top center;
    background-size: 100% 100%;
    color: #606266;
    overflow: hidden;
}
.container > div {
    display: inline-block;
    background:#fff;
    padding:50px;
    margin: 10% auto 0 auto;
    box-shadow: 1px 1px 15px 1px rgba(0,0,0, 0.1);
    border-radius:6px;
}
.iconfont {
    font-size: 512px;
    display: inline-block;
    margin-bottom: 35px;
}
</style>

